import { useEffect, useState, CSSProperties, Fragment } from "react";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useStyles } from "../../styles";
import { TextField } from "@material-ui/core";
import { deepCopy, httpsLink, isValidUrl, makeKey } from "modules/Utils";
import { clsx } from "clsx";
import useBrand from 'Hooks/useBrand';
import {
    websiteSubSectionContainer,
    tourDateListContainer,
    tourDateRow,
    tourDateDetail,
    tourDateDay,
    tourDateMonth,
    tourDateAddUploadContainer,
} from "../../utils";
import ReactDatePicker from "react-datepicker";
import dayjs from "dayjs";
import { sortBy } from 'lodash';
import Axios from 'helpers/Interceptor';
import BandsInTownConnect from "components/connect/BandsInTown";
import Sty from "modules/Sty";
import BandsInTownLogo from "assets/images/platforms/bandsintown.svg";
import { motion } from "framer-motion";
import useScreen from "Hooks/useScreen";
import ButtonSymphony from "elements/ButtonSymphony";
import Colors from "modules/Colors";
import SwitchSymphony from "elements/SwitchSymphony";
import ModalSymphony from "elements/ModalSymphony";
import useWebsite from "Hooks/useWebsite";
import { downloadTourDatesCsv_api, processTourDatesText_api } from "api/websiteApi";
import Divider from "elements/Divider";
import CardSymphony from "elements/CardSymphony";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import InputSymphony from "elements/InputSymphony";
import { WebsiteBuilder_tourExists } from "Hooks/useWebsiteBuilder";
import useWebsiteBuilder from "Hooks/useWebsiteBuilder";
import Icon from "elements/Icon";
import { TourDate } from "modules/Types";
import FileChooser from "elements/FileChooser";

const TOUR_TABS: TabItem[] = [
    { id: 'event_details', title: 'Event Details' },
    { id: 'date_customization', title: 'Date Customization' },
]

interface TourSetupSectionProps {
    contentIndex?: number;
    isNoPadding?: boolean;
    isWebsiteBuilder?: boolean;
}

const TourSetupSection = ({
    contentIndex = 0,
    isNoPadding = false,
    isWebsiteBuilder = false,
}: TourSetupSectionProps) => {
    const classes = useStyles();
    const { mobileView } = useScreen();
    const { currentBrand, getBrand } = useBrand()
    const {
        tourDates: tourDatesFromWebsiteStore,
        setTourDates,
        hidePastTourDates,
        setHidePastTourDates,
    } = useWebsite()

    const {
        websiteContent,
        setWebsiteContent,
    } = useWebsiteBuilder() as WebsiteBuilder_tourExists

    const tourDates = isWebsiteBuilder ? (websiteContent[contentIndex]?.tourContent?.tourDates || []) : tourDatesFromWebsiteStore || []

    const [localBandsintownUrl, setLocalBandsintownUrl] = useState<{ name: string } | null>(null);

    const userHasBandsintownConnected = localBandsintownUrl !== null;

    const [cityText, setCityText] = useState<string>('')
    const [countryText, setCountryText] = useState<string>('')
    const [currentDate, setCurrentDate] = useState<string>(dayjs().format("YYYY-MM-DD"));
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false)
    const [isEditTourDate, setIsEditTourDate] = useState<boolean>(false)
    const [isPreSaleDatePickerOpen, setIsPreSaleDatePickerOpen] = useState<boolean>(false);
    const [isPreSalePeriod, setIsPreSalePeriod] = useState<boolean>(false)
    const [isShowSoldOut, setIsShowSoldOut] = useState<boolean>(false)
    const [isTourDateModalOpen, setIsTourDateModalOpen] = useState<boolean>(false)
    const [preSaleDate, setPreSaleDate] = useState<string>(dayjs().format("YYYY-MM-DD"));
    const [regionText, setRegionText] = useState<string>('')
    const [ticketUrlText, setTicketUrlText] = useState<string>('')
    const [buttonLinkText, setButtonLinkText] = useState<string>('Buy')
    const [tourIndex, setTourIndex] = useState<number>(-1)
    const [venueText, setVenueText] = useState<string>('')

    const [selectedCsv, setSelectedCsv] = useState<File | undefined>(undefined);
    const [uploadingCsv, setUploadingCsv] = useState(false);
    const [errorCsv, setErrorCsv] = useState<string>('');

    const [pasteTourDatesModalOpen, setPasteTourDatesModalOpen] = useState(false);
    const [pasteTourDatesText, setPasteTourDatesText] = useState('');
    const [pasteTourDatesLoading, setPasteTourDatesLoading] = useState(false);
    const [pasteTourDatesError, setPasteTourDatesError] = useState<string>('');

    const [preSaleButtonText, setPreSaleButtonText] = useState<string>('');
    const [preSaleAction, setPreSaleAction] = useState<'collect' | 'link'>('collect');
    const [preSaleCustomLink, setPreSaleLinkText] = useState<string>('');

    const [googleSearchResults, setGoogleSearchResults] = useState<any[]>([]);
    const [selectedGoogleItem, setSelectedGoogleItem] = useState<any>(null);

    const [selectedTourTab, setSelectedTourTab] = useState<TabItem>(TOUR_TABS[0]);

    const [bandsintownSearchText, setBandsintownSearchText] = useState<string>('');

    const purpleRadioStyle = {
        accentColor: Colors.purple, // This sets the color of the radio button when checked
    };

    const [venueInputValue, setVenueInputValue] = useState('');
    const [showAutocomplete, setShowAutocomplete] = useState(false);
    const [selectedVenue, setSelectedVenue] = useState<{ name: string } | null>(null);

    const [ticketUrlError, setTicketUrlError] = useState<string>('');

    const [isBandsintownImportSectionOpen, setIsBandsintownImportSectionOpen] = useState<boolean>(false);
    const [bandsintownLoading, setBandsintownLoading] = useState<boolean>(false);
    const [isImportEventDropdown, setIsImportEventDropdown] = useState<boolean>(false);

    useEffect(() => {
        if (currentBrand?.connections?.bandsintown) {
            setLocalBandsintownUrl({ name: currentBrand.connections.bandsintown.name });
        }
    }, [currentBrand]);

    const setTourContentInWebsiteBuilder = ({
        tourDates,
        hidePastTourDates,
    }: {
        tourDates: TourDate[];
        hidePastTourDates: boolean;
    }) => {
        if (!isWebsiteBuilder) {
            return;
        }

        const websiteContentLocal = [...websiteContent]
        websiteContentLocal[contentIndex].tourContent.tourDates = tourDates
        websiteContentLocal[contentIndex].tourContent.hidePastTourDates = hidePastTourDates
        setWebsiteContent(websiteContentLocal)
    }

    // New function to handle venue selection
    const handleVenueSelection = (newValue: any) => {
        if (newValue) {
            setVenueText(newValue.name || '');
            setVenueInputValue(newValue.name || '');
            setCityText(newValue.city || '');
            setRegionText(newValue.state || '');
            setCountryText(newValue.country || '');
            setSelectedGoogleItem(newValue);
            setSelectedVenue({ name: newValue.name || '' });
        } else {
            setVenueText('');
            setVenueInputValue('');
            setSelectedGoogleItem(null);
            setSelectedVenue(null);
        }
    };

    // Updated handleVenueInputChange function
    const handleVenueInputChange = async (query: string) => {
        setVenueInputValue(query);
        setVenueText(query);

        if (query.length >= 2) {
            const results = await searchItems(query);
            if (results.length > 0) {
                setGoogleSearchResults([...results]);
                setShowAutocomplete(true);
            } else {
                setGoogleSearchResults([]);
                setShowAutocomplete(false);
            }
        } else {
            setGoogleSearchResults([]);
            setShowAutocomplete(false);
        }
    };

    useEffect(() => {
        if (isTourDateModalOpen) {
            return;
        }

        setCityText('');
        setCountryText('');
        setCurrentDate(dayjs().format("YYYY-MM-DD"));
        setIsPreSalePeriod(false);
        setIsShowSoldOut(false);
        setPreSaleDate(dayjs().format("YYYY-MM-DD"));
        setRegionText('');
        setTicketUrlText('');
        setButtonLinkText('Buy');
        setVenueText('');
        setVenueInputValue('');
        setPreSaleButtonText('');
        setPreSaleAction('collect');
        setPreSaleLinkText('');
        setSelectedGoogleItem(null);
        setGoogleSearchResults([]);
    }, [isTourDateModalOpen]);

    const handleEditTourDate = (index: number) => {
        setIsEditTourDate(true);
        setIsTourDateModalOpen(true);
        setTourIndex(index);

        const tourDate = tourDates[index];
        setCityText(tourDate.city);
        setCountryText(tourDate.country);
        setCurrentDate(tourDate.date);
        setIsPreSalePeriod(tourDate.isPreSalePeriod);
        setIsShowSoldOut(tourDate.isSoldOut);
        setPreSaleDate(tourDate.preSaleDate);
        setRegionText(tourDate.region);
        setTicketUrlText(tourDate.ticketUrl);
        setButtonLinkText(tourDate.buttonLinkText);
        setVenueText(tourDate.venue);
        setVenueInputValue(tourDate.venue);
        setSelectedVenue({ name: tourDate.venue });
        setPreSaleButtonText(tourDate.preSaleButtonText);
        setPreSaleAction(tourDate.preSaleAction);

        setPreSaleLinkText(tourDate.preSaleCustomLink);

        // Reset the selected Google item and search results
        setSelectedGoogleItem(null);
        setGoogleSearchResults([]);
    };

    const searchItems = async (query: string) => {
        if (query.length < 2) return [];

        try {
            const response = await Axios.get<any>(`/brand/${currentBrand?.slug}/google/autocomplete?q=${query}`);
            return response.data.results;
        } catch (error) {
            console.error('Search error:', error);
            return [];
        }
    };

    const importBandsInTownData = async () => {
        if (userHasBandsintownConnected) {
            setBandsintownLoading(true)
            try {
                const artistName = localBandsintownUrl?.name;
                const res = await Axios.get<any>(`/website/bandsintown/tour-dates?artist=${artistName}`);
                const bandsintownTourData = res.data.bandsintownTourData;

                transformTourDatesFromBandsInTown(bandsintownTourData)
            } catch (error) {
                console.error('Error importing BandsInTown data:', error);
            } finally {
                setBandsintownLoading(false)
            }
        } else {
            setIsBandsintownImportSectionOpen(true)
        }
    }

    const handleDeleteTourDate = (index: number) => {
        const newTourDates = deepCopy(tourDates)
        newTourDates.splice(index, 1)
        setTourDates(newTourDates)
        setTourContentInWebsiteBuilder({
            tourDates: newTourDates,
            hidePastTourDates: hidePastTourDates,
        })
    }

    const createNewTourDate = () => {
        const tourDate = {
            city: cityText,
            country: countryText,
            date: currentDate,
            isPreSalePeriod: isPreSalePeriod,
            isSoldOut: isShowSoldOut,
            preSaleDate: preSaleDate,
            region: regionText,
            ticketUrl: ticketUrlText,
            buttonLinkText,
            venue: venueText,
            preSaleButtonText: preSaleButtonText,
            preSaleAction,
            preSaleCustomLink: preSaleCustomLink,
            source: 'manual',
        }

        return tourDate;
    }

    const handleOpenTourDateModal = ({ isEdit }: { isEdit: boolean }) => {
        setIsTourDateModalOpen(true);
        setIsEditTourDate(isEdit);
    }

    const sortTourDates = (tourDatesLocal: any[]) => {
        const sortedTourDates = sortBy(tourDatesLocal, (tourDate) => new Date(tourDate.date));
        return sortedTourDates;
    }

    const handleAddEditTourDate = (tourIndex: number) => {
        const isValid = () => {
            if (!currentDate || (!venueText && !cityText)) {
                return false;
            }
            if (!ticketUrlText) {
                if (isPreSalePeriod) {
                    if (preSaleAction === 'collect' && !preSaleDate) {
                        return false;
                    }
                    if (preSaleAction === 'link' && !preSaleCustomLink) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
            if (ticketUrlError) {
                return false;
            }
            return true;
        };

        if (!isValid()) {
            return;
        }

        const tourDate = createNewTourDate()

        if (isEditTourDate) {
            let newTourDates = deepCopy(tourDates)
            newTourDates[tourIndex] = tourDate
            const sortedTourDates = sortTourDates(newTourDates)
            setTourDates(sortedTourDates)
            setTourContentInWebsiteBuilder({
                tourDates: sortedTourDates,
                hidePastTourDates: hidePastTourDates,
            })
        } else {
            ignoreDuplicateTourDateDates([tourDate])
        }

        setIsTourDateModalOpen(false)
    }

    const transformTourDatesFromCsv = (tourDatesFromCsv: any[]) => {
        const newTourDates = tourDatesFromCsv.map((tourDate) => {
            return {
                city: tourDate.city || '',
                country: tourDate.country || '',
                date: tourDate.date || null,
                displayName: '',
                isPreSalePeriod: false,
                isSoldOut: tourDate.soldout || false,
                preSaleDate: null,
                region: tourDate.region || '',
                ticketUrl: tourDate.ticketUrl || '',
                venue: tourDate.venue || '',
                preSaleButtonText: '',
                preSaleAction: 'collect',
                preSaleCustomLink: '',
                source: 'csv',
            }
        })

        ignoreDuplicateTourDateDates(newTourDates)
    }

    const ignoreDuplicateTourDateDates = (newTourDates: any[]) => {
        const filteredNewTourDates = newTourDates.filter((newTourDate) => {
            return !tourDates.some((existingTourDate) =>
                existingTourDate.date === newTourDate.date && existingTourDate.venue === newTourDate.venue
            );
        });
        const sortedTourDates = sortTourDates([...tourDates, ...filteredNewTourDates])
        setTourDates(sortedTourDates);
        setTourContentInWebsiteBuilder({
            tourDates: sortedTourDates,
            hidePastTourDates: hidePastTourDates,
        })
    }

    /**
     * Handles the CSV file upload process
     * @param file - The CSV file to be processed
     */
    const handleUploadCsv = async (file: File) => {
        try {
            setUploadingCsv(true);
            await processUploadedCsv(file);
        } catch (error) {
            setErrorCsv('An error occurred while uploading the file');
        } finally {
            setUploadingCsv(false);
        }
    };

    // Separate the file processing logic to simplify the handling
    const processUploadedCsv = async (csv: File) => {
        if (csv.size > 5 * 1024 * 1024) {
            setErrorCsv('File size limit is 5MB');
            return;
        }

        const formData = new FormData();
        setErrorCsv('');
        setUploadingCsv(true);
        formData.append('csv', csv);

        try {
            const response = await downloadTourDatesCsv_api(formData);
            const tourDatesFromCsv = response.tour_dates.dateArray;

            if (tourDatesFromCsv.length === 0) {
                setErrorCsv('We weren\'t able to find any events or tour dates found in the uploaded CSV.');
            } else {
                setSelectedCsv(csv);
                transformTourDatesFromCsv(tourDatesFromCsv);
            }
        } catch (error) {
            setErrorCsv('There was an error uploading your file');
            throw error; // Propagate error to the caller
        }
    };

    const handleDeleteCsv = () => {
        setSelectedCsv(undefined);
        setErrorCsv('');
    };

    const setIsShowSoldOutInRow = (isSoldOut: boolean, index: number) => {
        const newTourDates = deepCopy(tourDates)
        newTourDates[index].isSoldOut = isSoldOut
        setTourDates(newTourDates)
        setTourContentInWebsiteBuilder({
            tourDates: newTourDates,
            hidePastTourDates: hidePastTourDates,
        })
    }

    const transformTourDatesFromBandsInTown = async (bandsintownTourData: any) => {
        const transformedDates = bandsintownTourData.map((tourDate: any) => ({
            city: tourDate.venue.city || '',
            country: tourDate.venue.country || '',
            date: tourDate.datetime || null,
            displayName: '',
            isPreSalePeriod: false,
            isSoldOut: tourDate.sold_out || false,
            preSaleDate: null,
            region: tourDate.venue.region || '',
            ticketUrl: tourDate.offers[0]?.url || '', // Assuming the first offer is the relevant one
            venue: tourDate.venue.name || '',
            preSaleButtonText: '',
            preSaleAction: 'collect',
            preSaleCustomLink: '',
            source: 'bandsintown',
        }));

        ignoreDuplicateTourDateDates(transformedDates)
    }

    const renderAddTourDateButton = () => {
        let addDateButtonStyle: CSSProperties = {
            marginRight: tourDates.length ? 0 : 'auto',
            marginLeft: 'auto',
        }

        if (mobileView) {
            addDateButtonStyle = {
                marginLeft: 0,
                marginTop: 10,
                marginBottom: 10,
            }
        }

        return (
            <ButtonSymphony
                className="addDateButtonTour"
                onClick={() => handleOpenTourDateModal({ isEdit: false })}
                style={addDateButtonStyle}
                variant="outlined"
            >
                Add a date
            </ButtonSymphony>
        )
    }

    const renderUploadCsvButton = () => {
        return (
            <FileChooser
                onFileUpload={handleUploadCsv}
                label="Upload CSV File"
                className="uploadCsvButtonTour"
                isLoading={uploadingCsv}
            />
        );
    };

    /**
     * Handles the paste tour dates process
     * @param text - The text to be processed
     */
    const handlePasteTourDates = async (text: string) => {
        try {
            setPasteTourDatesLoading(true);
            setPasteTourDatesError('');
            
            const response = await processTourDatesText_api(text);
            const tourDatesFromText = response.tour_dates.dateArray;

            if (tourDatesFromText.length === 0) {
                setPasteTourDatesError('We weren\'t able to find any events or tour dates in the text.');
            } else {
                transformTourDatesFromCsv(tourDatesFromText);
                setPasteTourDatesModalOpen(false);
                setPasteTourDatesText('');
            }
        } catch (error) {
            setPasteTourDatesError('There was an error processing your text');
        } finally {
            setPasteTourDatesLoading(false);
        }
    };

    const renderPasteTourDatesButton = () => {
        return (
            <ButtonSymphony
                className="pasteTourDatesButton"
                onClick={() => setPasteTourDatesModalOpen(true)}
                variant="outlined"
            >
                Paste tour dates
            </ButtonSymphony>
        );
    };

    const renderPasteTourDatesModal = () => {
        return (
            <ModalSymphony
                className="pasteTourDatesModal"
                isOpen={pasteTourDatesModalOpen}
                onClose={() => {
                    setPasteTourDatesModalOpen(false);
                    setPasteTourDatesText('');
                    setPasteTourDatesError('');
                }}
                title="Paste in dates"
                subtitle="Paste in text with your tour dates and AI will automatically map it to your site"
                onClickButtonRight={() => handlePasteTourDates(pasteTourDatesText)}
                buttonRightText="Submit"
                buttonRightDisabled={!pasteTourDatesText.trim() || pasteTourDatesLoading}
                buttonRightIsLoading={pasteTourDatesLoading}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <InputSymphony
                        className="pasteTourDatesTextArea"
                        value={pasteTourDatesText}
                        onChange={(e: string) => setPasteTourDatesText(e)}
                        placeholder="Paste your tour dates here..."
                        isTextArea
                        rows={8}
                        style={{ minHeight: 200 }}
                    />
                    {pasteTourDatesError && (
                        <div style={{ color: 'red', fontSize: 14 }}>
                            {pasteTourDatesError}
                        </div>
                    )}
                </div>
            </ModalSymphony>
        );
    };

    const renderBandsintownImportButton = (connected: boolean) => {
        return (
            <div>
                <ButtonSymphony
                    className="bandsintownImportButton"
                    variant="outlined"
                    onClick={importBandsInTownData}
                    isLoading={bandsintownLoading}
                    iconRight={<img src={BandsInTownLogo} alt="BandsInTown Logo" />}
                >
                    {connected ? 'Refresh from ' : 'Connect '}
                </ButtonSymphony>
                {localBandsintownUrl && localBandsintownUrl.name && (
                    <div style={{ marginTop: '8px', fontSize: '14px', color: '#666', textAlign: 'center' }}>
                        Connected: {localBandsintownUrl.name}
                    </div>
                )}
            </div>
        )
    }

    const renderTourDateRow = ({
        tourDate,
        index,
    }: {
        tourDate: any;
        index: number;
    }) => {
        const date = tourDate.date;
        const day = dayjs(date).format('DD')
        const month = dayjs(date).format('MMM')
        const isPastDate = dayjs(date).isBefore(dayjs().subtract(1, 'day'), 'day');

        const truncateVenue = (venue: string) => {
            if (mobileView && venue.length > 16) {
                return venue.slice(0, 16) + '...';
            }
            return venue;
        };

        const renderPreSaleInfo = () => {
            if (tourDate.isPreSalePeriod && !tourDate.isSoldOut) {
                const preSaleEmoji = tourDate.preSaleAction === 'collect' ? '📧' : '🔗';
                const preSaleAction = tourDate.preSaleAction === 'collect'
                    ? 'Collecting Emails'
                    : 'Custom Link';
                const preSaleText = `${preSaleEmoji} Pre-Sale: ${preSaleAction}`;

                if (tourDate.preSaleDate) {
                    if (dayjs(tourDate.preSaleDate).isAfter(dayjs())) {
                        return `${preSaleText} until ${dayjs(tourDate.preSaleDate).format('MM/DD')}`;
                    } else if (!tourDate.ticketUrl) {
                        return `${preSaleText} - Missing ticket link`;
                    }
                }

                return preSaleText;
            }
            return null;
        };

        const renderTicketInfo = () => {
            if (tourDate.isPreSalePeriod) {
                return renderPreSaleInfo();
            }

            if (tourDate.isSoldOut) {
                return "Tickets marked sold out";
            }

            if (tourDate.ticketUrl && !isPastDate) {
                return "Tickets on sale";
            }

            if (isPastDate) {
                return null
            }

            return "No ticket link entered.";
        };

        return (
            <motion.div
                className={makeKey('tourDateRow', index)}
                style={{ ...tourDateRow, justifyContent: 'space-between' }}
                initial={{ backgroundColor: 'red' }}
                animate={{ backgroundColor: 'white' }}
                transition={{ duration: 5000 }}
            >
                <div className="tourDateDetail" style={tourDateDetail}>
                    <div className="tourDateMonth" style={tourDateMonth}>
                        {month}
                    </div>
                    <div className="previewTourDateDay" style={tourDateDay}>
                        {day}
                    </div>
                </div>

                <div className="tourDateDetails" style={{ flex: 1, minWidth: 0, marginRight: 16 }}>
                    {isPastDate && (
                        <div
                            className="pastDate"
                            style={{
                                fontSize: 12,
                                color: Colors.yellow,
                                marginBottom: 2
                            }}
                        >
                            (Past Date)
                        </div>
                    )}
                    <div className="tourDateVenue" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {truncateVenue(tourDate.venue)}
                    </div>
                    <div className="tourDateCity" style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...Sty.text16grey }}>
                        {[tourDate.city, tourDate.region].filter(Boolean).join(', ')}
                    </div>
                    {(renderPreSaleInfo() || renderTicketInfo()) && (
                        <div
                            className="preSaleInfo"
                            style={{
                                ...Sty.text12grey,
                                marginTop: 2
                            }}
                        >
                            {renderPreSaleInfo() || renderTicketInfo()}
                        </div>
                    )}
                </div>

                <div className="tourDateActions" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {!mobileView && (
                        <div className={classes.secondaryTextSection} style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <SwitchSymphony
                                className="soldOutSwitch"
                                checked={tourDate.isSoldOut}
                                onChange={() => setIsShowSoldOutInRow(!tourDate.isSoldOut, index)}
                            />
                            <div className='addSecondaryText' style={Sty.text14grey}>
                                Sold Out
                            </div>
                        </div>
                    )}
                    <Icon
                        className="editTourDate"
                        onClick={() => handleEditTourDate(index)}
                        color={Colors.greyDark}
                        icon="edit"
                    />
                    <Icon
                        className="trashTourDate"
                        onClick={() => handleDeleteTourDate(index)}
                        color={Colors.greyDark}
                        icon="trash"
                    />
                </div>
            </motion.div>
        );
    }

    const renderTourDateList = () => {
        return (
            <div className="tourDateListContainer" style={tourDateListContainer}>
                {tourDates.map((tourDate, index) => (
                    <Fragment key={makeKey('tourDateRow', index)}>
                        {renderTourDateRow({ tourDate, index })}
                    </Fragment>
                ))}
            </div>
        );
    }

    const TourReactDatePicker = () => {
        return (
            <ReactDatePicker
                filterDate={(date: Date) => {
                    return dayjs(date).isAfter(dayjs(), 'day') || dayjs(date).isSame(dayjs(), 'day');
                }}
                selected={currentDate ? dayjs(currentDate).toDate() : null}
                onChange={(date) => {
                    if (date) {
                        const newDate = dayjs(date).format("YYYY-MM-DD");
                        setCurrentDate(newDate);
                    }
                }}
                customInput={<input style={Sty.input} type='text' placeholder='Event Date' />}
                onCalendarOpen={() => setIsDatePickerOpen(true)}
                onCalendarClose={() => setIsDatePickerOpen(false)}
            />
        )
    }

    const renderPreSaleDatePicker = () => {
        return (
            <ReactDatePicker
                filterDate={(date: Date) => {
                    return dayjs(date).isAfter(dayjs(), 'day') || dayjs(date).isSame(dayjs(), 'day');
                }}
                placeholderText="Select a date"
                selected={preSaleDate ? dayjs(preSaleDate).toDate() : null}
                onChange={(date) => {
                    if (date) {
                        const newDate = dayjs(date).format("YYYY-MM-DD");
                        setPreSaleDate(newDate);
                    }
                }}
                customInput={
                    <input
                        style={Sty.input}
                        type='text'
                        placeholder='Select a date'
                        value={preSaleDate ? dayjs(preSaleDate).format("MM/DD/YYYY") : ''}
                    />
                }
                onCalendarOpen={() => setIsPreSaleDatePickerOpen(true)}
                onCalendarClose={() => setIsPreSaleDatePickerOpen(false)}
            />
        )
    }
    const renderSaveUpdateButton = () => {
        const isDisabled = () => {
            if (!currentDate || (!venueText && !cityText)) {
                return true;
            }
            if (!ticketUrlText) {
                if (isPreSalePeriod) {
                    if (preSaleAction === 'collect' && !preSaleDate) {
                        return true;
                    }
                    if (preSaleAction === 'link' && !preSaleCustomLink) {
                        return true;
                    }
                } else {
                    return true;
                }
            }
            if (ticketUrlError) {
                return true;
            }
            return false;
        };

        const getMissingFieldsMessage = () => {
            const missingFields = [];
            if (!currentDate) missingFields.push('Date');
            if (!venueText && !cityText) missingFields.push('Venue or City');
            if (!ticketUrlText && !isPreSalePeriod) missingFields.push('Ticket Link');
            if (isPreSalePeriod) {
                if (preSaleAction === 'collect' && !preSaleDate) missingFields.push('Pre-sale Date');
                if (preSaleAction === 'link' && !preSaleCustomLink) missingFields.push('Pre-sale Link');
            }

            if (missingFields.length === 0) {
                return ''
            }
            return `Please fill in the following required fields: ${missingFields.join(', ')}`;
        };

        return (
            <div
                className="saveUpdateButtonContainer"
                style={{
                    position: 'sticky',
                    bottom: -24,
                    left: 0,
                    right: 0,
                    width: '100%',
                    paddingTop: 16,
                    paddingBottom: 16,
                    backgroundColor: Colors.PAPER_CONTAINER,
                    borderTop: `1px solid ${Colors.divider}`,
                }}
            >
                {isDisabled() &&
                    <div className="missingFieldsContainer" style={{ paddingTop: 8, paddingBottom: 8, paddingLeft: 16, paddingRight: 16 }}>
                        <div
                            className="missingFieldsMessage"
                            style={{
                                color: Colors.yellow,
                                textAlign: 'center',
                                marginBottom: 4
                            }}
                        >
                            {getMissingFieldsMessage()}
                        </div>
                        {!ticketUrlText && !isPreSalePeriod &&
                            <div
                                className="missingFieldsMessage"
                                style={{
                                    color: Colors.yellow,
                                    textAlign: 'center'
                                }}
                            >
                                You can either add a ticket link or set up a pre-sale.
                            </div>
                        }
                    </div>
                }
                <ButtonSymphony
                    className='addTourDateButton'
                    onClick={() => handleAddEditTourDate(tourIndex)}
                    width='100%'
                    disabled={isDisabled()}
                >
                    {isEditTourDate ? 'Update' : 'Save'}
                </ButtonSymphony>
            </div>
        )
    }

    const renderEventDetailsTab = () => {
        const validateTicketUrl = (url: string) => {
            if (url && !isValidUrl(url)) {
                setTicketUrlError('Please enter a valid URL (e.g., https://example.com)');
            } else {
                setTicketUrlError('');
            }
        };

        return (
            <div className="eventDetailsContainer" style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <CardSymphony
                    className="eventDateHeader"
                    title="Event Date"
                    size="small"
                    isNoPadding
                    style={{ gap: 8 }}
                >
                    <TourReactDatePicker />
                </CardSymphony>

                <CardSymphony
                    className="ticketLinkHeader"
                    title="Ticket Link"
                    size="small"
                    isNoPadding
                    style={{ gap: 8 }}
                >
                    <InputSymphony
                        className="ticketLinkInput"
                        style={{
                            borderColor: ticketUrlError ? Colors.red : undefined,
                        }}
                        placeholder='https://ticketmaster.com/xyz'
                        value={ticketUrlText}
                        onChange={(value) => {
                            setTicketUrlText(value);
                            validateTicketUrl(value);
                        }}
                        onBlur={(value: string) => {
                            const ticketUrlLocal = httpsLink(value);
                            setTicketUrlText(ticketUrlLocal);

                            validateTicketUrl(value);
                        }}
                    />
                    {ticketUrlError &&
                        <div className="ticketUrlError" style={{ ...Sty.text14, color: Colors.red, marginTop: 4 }}>
                            {ticketUrlError}
                        </div>
                    }
                </CardSymphony>

                <CardSymphony
                    className="actionButtonHeader"
                    title="Action Button Text"
                    size="small"
                    isNoPadding
                    style={{ gap: 8 }}
                >
                    <InputSymphony
                        className="actionButtonTextInput"
                        placeholder='Buy Now'
                        value={buttonLinkText}
                        onChange={(value) => setButtonLinkText(value)}
                        maxLength={30}
                    />
                </CardSymphony>

                <CardSymphony
                    className="locationHeader"
                    title="Location"
                    subtitle="Enter any or all of the location details around your event - we'll automatically format it. A venue or city is required."
                    size="small"
                    isNoPadding
                    style={{ gap: 8 }}
                >
                    <Autocomplete
                        options={googleSearchResults}
                        getOptionLabel={(option: any) => option.name || ''}
                        renderOption={(props, option: any) => {
                            const { name, city, state, country } = props;
                            let locationString = '';
                            if (city) locationString += city;
                            if (state) locationString += (locationString ? ', ' : '') + state;
                            if (country) locationString += (locationString ? ', ' : '') + country;

                            return (
                                <li {...props}>
                                    <div style={{ fontFamily: 'DIN' }}>
                                        {name && <div>{name}</div>}
                                        {locationString && (
                                            <div style={{ fontSize: '0.8em', color: 'gray' }}>
                                                {locationString}
                                            </div>
                                        )}
                                    </div>
                                </li>
                            );
                        }}
                        onChange={(event, newValue: any) => handleVenueSelection(newValue)}
                        inputValue={venueInputValue}
                        onInputChange={(event, newInputValue) => handleVenueInputChange(newInputValue)}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder='Venue Name'
                                InputProps={{
                                    ...params.InputProps,
                                    style: {
                                        ...Sty.input,
                                        padding: 0,
                                        fontFamily: 'DIN',
                                    },
                                    disableUnderline: true
                                }}
                                inputProps={{
                                    ...params.inputProps,
                                    style: {
                                        ...Sty.input,
                                        fontFamily: 'DIN',
                                    },
                                }}
                            />
                        )}
                        freeSolo
                        value={selectedVenue}
                        open={showAutocomplete}
                        onClose={() => setShowAutocomplete(false)}
                        filterOptions={(x) => x}
                    />
                    <InputSymphony
                        className="cityInput"
                        placeholder='City'
                        value={cityText}
                        onChange={(value) => setCityText(value)}
                    />
                    <InputSymphony
                        className="regionInput"
                        placeholder='State / Region'
                        value={regionText}
                        onChange={(value) => setRegionText(value)}
                    />
                    <InputSymphony
                        className="countryInput"
                        placeholder='Country'
                        value={countryText}
                        onChange={(value) => setCountryText(value)}
                    />
                </CardSymphony>

                <SwitchSymphony
                    className="soldOutSwitch"
                    checked={isShowSoldOut}
                    onChange={() => setIsShowSoldOut(!isShowSoldOut)}
                    label="Mark as Sold Out"
                />

                {renderSaveUpdateButton()}
            </div>
        )
    }

    const renderDateCustomizationTab = () => {
        return (
            <div className="preSalePeriodContainer" style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
                <SwitchSymphony
                    className="preSalePeriodSwitch"
                    checked={isPreSalePeriod}
                    onChange={() => setIsPreSalePeriod(!isPreSalePeriod)}
                    label="Add Pre-sale Period"
                />

                {isPreSalePeriod && (
                    <>
                        <CardSymphony
                            className="preSaleActionsHeader"
                            title="Pre-sale Actions"
                            size="small"
                            isNoPadding
                            style={{ gap: 8 }}
                        >
                            <div className={classes.radioButtonContainer}>
                                <input
                                    type="radio"
                                    id="collect"
                                    name="preSaleAction"
                                    value="collect"
                                    checked={preSaleAction === 'collect'}
                                    onChange={() => setPreSaleAction('collect')}
                                    style={purpleRadioStyle}
                                />
                                <label htmlFor="collect" style={{ color: Colors.greyDark }}>Collect emails & numbers</label>
                            </div>
                            <div className={classes.radioButtonContainer}>
                                <input
                                    type="radio"
                                    id="link"
                                    name="preSaleAction"
                                    value="link"
                                    checked={preSaleAction === 'link'}
                                    onChange={() => setPreSaleAction('link')}
                                    style={purpleRadioStyle}
                                />
                                <label htmlFor="link" style={{ color: Colors.greyDark }}>Open a custom link</label>
                            </div>
                        </CardSymphony>

                        {preSaleAction === 'link' && (
                            <CardSymphony
                                className="customLinkHeader"
                                title="Custom Link"
                                subtitle="When a fan clicks on your pre-sale button, they'll be sent to this link"
                                size="small"
                                isNoPadding
                            >
                                <InputSymphony
                                    className="customLinkInput"
                                    placeholder='Enter custom link'
                                    value={preSaleCustomLink}
                                    onChange={(value) => setPreSaleLinkText(value)}
                                />
                            </CardSymphony>
                        )}

                        <CardSymphony
                            className="preSaleDateHeader"
                            title="Pre-sale End Date"
                            subtitle="Once your pre-sale date passes, your ticket link will be shown to fans. If your ticket link is empty, we'll continue showing pre-sale until you enter it in."
                            size="small"
                            isNoPadding
                        >
                            {renderPreSaleDatePicker()}
                        </CardSymphony>

                        <CardSymphony
                            className="preSaleButtonTextHeader"
                            title="Pre-sale Button Text"
                            subtitle="Customize pre-sale button text (max 10 characters)"
                            size="small"
                            isNoPadding
                        >
                            <InputSymphony
                                className="preSaleButtonTextInput"
                                placeholder='Signup'
                                value={preSaleButtonText}
                                onChange={(value) => setPreSaleButtonText(value.slice(0, 10))}
                                maxLength={10}
                            />
                        </CardSymphony>
                    </>
                )}

                {renderSaveUpdateButton()}
            </div>
        )
    }

    const renderTourDateModal = () => {
        return (
            <ModalSymphony
                className="tourDateModal"
                isOpen={isTourDateModalOpen}
                onClose={() => setIsTourDateModalOpen(false)}
                title="Add a tour date"
                subtitle="Add details for an event to display on your website. This can be a one-off event or a tour stop."
                fullScreen={mobileView}
                style={{ gap: 16 }}
            >
                <TabsSymphony
                    className='symphonyTabsTourSetupSection'
                    tabs={TOUR_TABS}
                    selectedTab={selectedTourTab}
                    onChange={(tab) => setSelectedTourTab(tab as TabItem)}
                />
                {selectedTourTab.id === 'event_details' &&
                    renderEventDetailsTab()
                }
                {selectedTourTab.id === 'date_customization' &&
                    renderDateCustomizationTab()
                }
            </ModalSymphony>
        );
    }

    const renderBandsintownImportModal = () => {
        return (
            <BandsInTownConnect
                isOpen={isBandsintownImportSectionOpen}
                closeModal={() => setIsBandsintownImportSectionOpen(false)}
                selected={currentBrand}
                artist={currentBrand}
                localSave={(data: any) => {
                    setLocalBandsintownUrl(data)
                    getBrand()
                }}
                getDataCallback={transformTourDatesFromBandsInTown}
            />
        )
    }

    const renderImportEventsDropdown = () => {
        return (
            <>
                <div
                    className="importEventsDropdownContainer"
                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <div style={Sty.text16grey}>
                        Events
                    </div>
                    <ButtonSymphony
                        className="importEventsDropdownButton"
                        onClick={() => setIsImportEventDropdown(!isImportEventDropdown)}
                        variant="text"
                        iconRight={isImportEventDropdown ? 'chevronUp' : 'chevronDown'}
                    >
                        Import Events
                    </ButtonSymphony>
                </div>
                <Divider />

                {isImportEventDropdown && (
                    <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: isImportEventDropdown ? 1 : 0, height: isImportEventDropdown ? 'auto' : 0 }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className="importEventsDropdownContent" style={{ marginBottom: 24 }}>
                            <div
                                style={{ ...websiteSubSectionContainer, flexDirection: 'column' }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', flexDirection: mobileView ? 'column' : 'row', gap: '16px' }}>
                                    {/* {renderBandsintownImportButton(userHasBandsintownConnected)} */}
                                    {renderUploadCsvButton()}
                                    {renderPasteTourDatesButton()}
                                </div>
                                {renderTourDateUploadErrorMessage()}
                            </div>
                        </div>
                    </motion.div>
                )}
            </>
        )
    }

    const renderTourDateUploadErrorMessage = () => {
        if (!errorCsv) return null;
        return (
            <div className="tourDateUploadErrorMessage" style={{ marginTop: 10 }}>
                <div style={{ color: 'red' }}>{errorCsv}</div>
            </div>
        )
    }

    // NOTE: render function
    return (
        <>
            <CardSymphony
                className="setupYourTourTitle"
                title="Setup your Events"
                subtitle="Add one or more event or tour dates to showcase"
                size="small"
                isNoPadding={isNoPadding}
            >
                {tourDates.length !== 0 && renderAddTourDateButton()}

                {tourDates.length !== 0 && renderImportEventsDropdown()}

                {!tourDates.length &&
                    <div className='tourDateContainer' style={websiteSubSectionContainer}>
                        <div
                            style={{ ...Sty.text16grey, textAlign: 'center' }}
                        >
                            You don't have any events added yet.<br />Get started with your first event.
                        </div>
                        <div style={{ ...tourDateAddUploadContainer, flexDirection: mobileView ? 'column' : 'row' }}>
                            {renderAddTourDateButton()}
                            {renderUploadCsvButton()}
                            {renderPasteTourDatesButton()}
                        </div>

                        {/* <div>
                                {renderBandsintownImportButton(userHasBandsintownConnected)}
                            </div> */}
                        {errorCsv && renderTourDateUploadErrorMessage()}
                    </div>
                }

                {renderTourDateList()}
            </CardSymphony>
            <CardSymphony
                title='Additional Options'
                className="additionalOptionsTour"
                size="small"
                isNoPadding={isNoPadding}
            >
                <div className={classes.secondaryTextSection}>
                    <SwitchSymphony
                        className={clsx(hidePastTourDates && classes.switchEnabled)}
                        checked={hidePastTourDates}
                        onChange={() => {
                            setHidePastTourDates(!hidePastTourDates)
                            setTourContentInWebsiteBuilder({
                                tourDates: tourDates,
                                hidePastTourDates: !hidePastTourDates,
                            })
                        }}
                        label="Hide past dates from your tour page"
                    />
                </div>
            </CardSymphony>

            {/* MODALS */}
            {renderTourDateModal()}
            {renderBandsintownImportModal()}
            {renderPasteTourDatesModal()}
        </>
    )
}

export default TourSetupSection;